import { useMemo } from "react";
import { store } from "../constant/string";

export const useAuthConfig = () => {
  const config = useMemo(() => {
    try {
      const userStr = localStorage.getItem(store);
      if (!userStr)
        return { headers: { "Content-Type": "application/json" } };

      const userObj = JSON.parse(userStr);
      const token = userObj?.authenticationTOKEN;

      return {
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      };
    } catch (error) {
      console.warn("Failed to parse user from localStorage:", error);
      return { headers: { "Content-Type": "application/json" } };
    }
  }, []); 

  return config;
};
